var a={};export{a as default};
//# sourceMappingURL=validation.js.map